/** @format */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {},
  isLoggedIn: false,
  inscrito: {},
  finalizados: {},
  isLoadingFinalizados: false,
  // sitePath: "http://localhost/admin/admin_cursos/webroot/mySiteProject",
  // sitePath: "fundacionunam.org/test/admin_cei/",
  sitePath:
    "https://fundacionunam.org/educacion_continua/admin_cursos/webroot/mySiteProject",
  contador: 0,
  isMobileNavActive: false,
  paramURL: false,
  pagos: [],
};

const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    signIn: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      state.isLoggedIn = true;
    },
    signOut: (state) => {
      state.user = {};
      state.isLoggedIn = false;
    },
    usuarioInscrito: (state, action) => {
      state.inscrito = { ...action.payload };
    },
    cursosFinalizadosDispatchStart: (state) => {
      state.isLoadingFinalizados = true;
    },
    cursosFinalizadosDispatchSuccess: (state, action) => {
      state.finalizados = { ...action.payload };
      state.isLoadingFinalizados = false;
    },
    recargarComponente: (state) => {
      state.contador += 1;
    },
    toggleMobileNav: (state) => {
      state.isMobileNavActive = !state.isMobileNavActive;
    },
    fillParamURL: (state, action) => {
      state.paramURL = action.payload;
    },
    pagosRegistrados: (state, action) => {
      state.pagos = action.payload;
    },
  },
});

export const {
  signIn,
  signOut,
  usuarioInscrito,
  cursosFinalizadosDispatchStart,
  cursosFinalizadosDispatchSuccess,
  recargarComponente,
  toggleMobileNav,
  fillParamURL,
  pagosRegistrados,
} = userSlice.actions;
export default userSlice.reducer;
